import { useEffect, useRef, useState } from "react";
import type { TranslationKeys } from "../../../i18n";
import { useAuth } from "../../../hooks/useBCT";
import "./Header.css";
import logo from '../../../../public/assets/images/edwards_logo1.png';
import { FaChevronDown } from "react-icons/fa6";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
type LanguageCode = "EN" | "FR" | "DE";

const Header = () => {
  const { t, i18n } = useTranslation<TranslationKeys>();
  const { user, logout } = useAuth();
  const [languageOpen, setLanguageOpen] = useState(false);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const languageRef = useRef<HTMLDivElement>(null);
  const profileRef = useRef<HTMLDivElement>(null);
  const languages: LanguageCode[] = ["EN", "FR", "DE"];

  const [selectedLanguage, setSelectedLanguage] = useState<LanguageCode>(() => {
    const saved = localStorage.getItem("app-language");
    return (saved?.toUpperCase() as LanguageCode) || "EN";
  });

  useEffect(() => {
    const langCode = selectedLanguage.toLowerCase();
    i18n.changeLanguage(langCode);
    localStorage.setItem("app-language", langCode);
  }, [selectedLanguage, i18n]);

  const handleLanguageSelect = (lang: LanguageCode) => {
    setSelectedLanguage(lang);
    setLanguageOpen(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (languageRef.current && !languageRef.current.contains(event.target as Node)) {
      setLanguageOpen(false);
    }
    if (profileRef.current && !profileRef.current.contains(event.target as Node)) {
      setProfileMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="header">
      <div className="header-top-row">
        <div className="header-section logo-section">
          <img src={logo} alt="Edwards Logo" className="logo" />
        </div>

        <div className="header-section middle-section">
          <Typography 
            variant="h2" 
            sx={{ 
              fontWeight: 600, 
              color: 'var(--text-primary)', 
              textAlign: 'start', 
              flexGrow: 1 
            }}
          >
            Business Case Tracker
          </Typography>
        </div>
        <div className="header-divider" />

        <div className="header-section language-section" ref={languageRef}>
          <div className="language" onClick={() => setLanguageOpen((prev) => !prev)}>
            <span className="label">{t("LANGUAGE")}</span>
            <span className="value">
              {selectedLanguage} <FaChevronDown className="dropdown-icon" />
            </span>

            {languageOpen && (
              <ul className="language-dropdown">
                {languages.map((lang) => (
                  <li key={lang} onClick={(e) => {
                    e.stopPropagation(); 
                    handleLanguageSelect(lang);
                  }}>
                    {lang}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>

        <div className="header-divider" />

        <div className="header-section profile-section" ref={profileRef}>
          <img src={user?.photoUrl} alt="Profile" className="profile-pic" />
          <div className="profile-info"  onClick={() => setProfileMenuOpen(!profileMenuOpen)}>
            <span className="name">{user?.name}</span>
            <span className="title">
              {user?.jobTitle} <FaChevronDown className="dropdown-icon" />
            </span>

            {profileMenuOpen && (
              <div className="profile-dropdown">
                <button onClick={logout}>{t("logout")}</button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* <div className={`header-menu-row ${menuItems.length > 0 ? "has-menu" : "no-menu"}`}>
        <div className="bottom-item menu-tab" onClick={() => setMenuOpen(!menuOpen)}>
          <FaBars />
          <span>{t("MENU")}</span>
        </div>

        {menuOpen &&
          menuItems.map((item) => (
            <div key={item} className="bottom-item menu-item">
           {t(item)}  <FaChevronDown className="dropdown-icon" />
            </div>
          ))}
      </div> */}
    </header>
  );
};

export default Header;
